<template>
  <section class="blog-container" aria-label="Blog Técnico da FFJB">
    <header>
      <h1 class="blog-title">Blog Técnico da FFJB</h1>
    </header>

    <div class="articles-grid">
      <article class="article-card" v-for="artigo in artigos" :key="artigo.id" tabindex="0"
        aria-labelledby="'title-' + artigo.id">
        <img :src="artigo.imagem" :alt="artigo.titulo" class="article-image" loading="lazy" />
        <div class="article-content">
          <div class="article-meta">
            <i :class="artigo.icone + ' article-icon'" aria-hidden="true"></i>
            <time class="article-date" :datetime="formatDateISO(artigo.data)">
              {{ artigo.data }}
            </time>
          </div>
          <h2 class="article-title" :id="'title-' + artigo.id">{{ artigo.titulo }}</h2>
          <p class="article-summary">{{ artigo.resumo }}</p>
          <button @click="openModal(artigo)" class="read-more-button" aria-haspopup="dialog" aria-controls="modal"
            aria-expanded="false">
            Saiba Mais
          </button>
        </div>
      </article>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal" role="dialog" aria-modal="true"
      aria-labelledby="modal-title" id="modal" tabindex="-1" ref="modal">
      <div class="modal-content" tabindex="0">
        <button class="close-button" @click="closeModal" aria-label="Fechar modal">×</button>
        <h2 class="modal-title" id="modal-title">{{ modalTitle }}</h2>
        <p class="modal-date">Publicado em {{ modalDate }}</p>
        <p class="modal-text">{{ modalContent }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
      modalTitle: '',
      modalContent: '',
      modalDate: '',
      artigos: [
        {
          id: 1,
          titulo: 'Manutenção Profissional de Ar Condicionado',
          data: '04 de Maio de 2025',
          resumo:
            'Dicas para eficiência, economia e vida útil do seu sistema de climatização.',
          imagem:
            'https://i.pinimg.com/736x/8b/c3/48/8bc3484298ef41ec6e8a104697c83c84.jpg',
          icone: 'lucide lucide-air-vent',
          conteudo: `A manutenção preventiva de ar condicionado é essencial para garantir eficiência, economia e longevidade do equipamento...`
        },
        {
          id: 2,
          titulo: 'Benefícios da Automação Industrial',
          data: '20 de Abril de 2025',
          resumo:
            'Como a automação revoluciona processos e aumenta a produtividade.',
          imagem:
            'https://i.pinimg.com/736x/80/39/e1/8039e1bb9bfe9f7a05748371c53bcffb.jpg',
          icone: 'lucide lucide-cpu',
          conteudo: `A automação industrial permite controlar processos complexos com maior precisão, reduzindo custos e erros...`
        },
        {
          id: 3,
          titulo: 'Portas Automáticas: Qual Escolher?',
          data: '12 de Abril de 2025',
          resumo:
            'Compare modelos para galpões, escritórios e residências.',
          imagem:
            'https://i.pinimg.com/736x/08/8e/ef/088eeff5469562fec67032a725ff92f3.jpg',
          icone: 'lucide lucide-door-open',
          conteudo: `Portas automáticas são ideais para facilitar o acesso e melhorar a segurança em diferentes ambientes...`
        },
        {
          id: 4,
          titulo: 'Automação Residencial: Conforto Inteligente',
          data: '18 de Março de 2025',
          resumo:
            'Tecnologia na palma da sua mão com integração e economia.',
          imagem:
            'https://i.pinimg.com/736x/f0/aa/b2/f0aab21f286a9323630188f2a1a2db69.jpg',
          icone: 'lucide lucide-home',
          conteudo: `A automação residencial integra iluminação, climatização e segurança, trazendo praticidade e economia para sua casa...`
        }
      ]
    };
  },
  methods: {
    openModal(artigo) {
      this.modalTitle = artigo.titulo;
      this.modalContent = artigo.conteudo;
      this.modalDate = artigo.data;
      this.showModal = true;
      this.$nextTick(() => {
        this.$refs.modal.focus();
      });
    },
    closeModal() {
      this.showModal = false;
    },
    formatDateISO(dateStr) {
      // converte data em formato "04 de Maio de 2025" para "2025-05-04"
      const meses = {
        Janeiro: '01',
        Fevereiro: '02',
        Março: '03',
        Abril: '04',
        Maio: '05',
        Junho: '06',
        Julho: '07',
        Agosto: '08',
        Setembro: '09',
        Outubro: '10',
        Novembro: '11',
        Dezembro: '12'
      };
      const parts = dateStr.match(/(\d{1,2}) de (\w+) de (\d{4})/);
      if (!parts) return '';
      const dia = parts[1].padStart(2, '0');
      const mes = meses[parts[2]] || '01';
      const ano = parts[3];
      return `${ano}-${mes}-${dia}`;
    }
  }
};
</script>

<style scoped>
/* Container geral */
.blog-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #1e1e1e;
  background: linear-gradient(135deg, #f5f9ff, #e6f0fa);
  user-select: none;
}

/* Título principal */
.blog-title {
  text-align: center;
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  margin-bottom: 60px;
  letter-spacing: 1.2px;
  color: #004070;
  text-transform: uppercase;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

/* Grid responsivo para os artigos */
.articles-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* 2 colunas fixas */
  gap: 28px;
  padding: 0 10px;
}


/* Card do artigo */
.article-card {
  max-width: 500px; /* controla o tamanho do card */
  margin: 0 auto;
}

.article-card:focus,
.article-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 30px rgba(0, 112, 192, 0.3);
  outline: none;
}

/* Imagem do artigo */
.article-image {
  width: 100%;
  max-height: 500px;
  object-fit: cover;
  border-bottom: 3px solid #004070;
  transition: transform 0.3s ease;
  border-radius: 10px; /* opcional para visual mais suave */
}

.article-card:hover .article-image,
.article-card:focus .article-image {
  transform: scale(1.05);
}

/* Conteúdo do artigo */
.article-content {
  padding: 22px 24px 28px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
}

/* Meta informação */
.article-meta {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: #007acc;
  font-size: 14px;
  margin-bottom: 14px;
}

.article-icon {
  font-size: 20px;
  color: #007acc;
  transition: color 0.3s ease;
}

/* Título do artigo */
.article-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 12px;
  line-height: 1.2;
  min-height: 3.3em;
  /* limitar altura para alinhar cards */
}

/* Resumo do artigo */
.article-summary {
  color: #555;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 20px;
  min-height: 3.6em;
  /* limitar altura para alinhar cards */
}

/* Botão Saiba Mais */
.read-more-button {
  background-color: #007acc;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 10px 24px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  align-self: center;
  box-shadow: 0 6px 12px rgba(0, 122, 204, 0.35);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  user-select: none;
}

.read-more-button:hover,
.read-more-button:focus {
  background-color: #005fa3;
  box-shadow: 0 8px 16px rgba(0, 95, 163, 0.45);
  outline: none;
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(25, 25, 25, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease forwards;
}

/* Conteúdo Modal */
.modal-content {
  background-color: #fff;
  padding: 36px 40px;
  border-radius: 18px;
  max-width: 720px;
  width: 90%;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  animation: scaleIn 0.35s ease forwards;
  outline: none;
  user-select: text;
}

/* Título Modal */
.modal-title {
  font-size: 2rem;
  font-weight: 700;
  color: #004070;
  margin-bottom: 12px;
  text-align: center;
  text-transform: uppercase;
}

/* Data Modal */
.modal-date {
  font-size: 0.875rem;
  color: #666;
  margin-bottom: 24px;
  text-align: center;
  font-style: italic;
}

/* Texto Modal */
.modal-text {
  font-size: 1rem;
  color: #333;
  line-height: 1.7;
  white-space: pre-line;
}

/* Botão fechar */
.close-button {
  position: absolute;
  top: 16px;
  right: 20px;
  font-size: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #999;
  transition: color 0.3s ease;
  user-select: none;
}

.close-button:hover,
.close-button:focus {
  color: #d33;
  outline: none;
}

/* Animações */
@keyframes scaleIn {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    background-color: rgba(25, 25, 25, 0);
  }

  100% {
    background-color: rgba(25, 25, 25, 0.85);
  }
}

/* Scrollbar customizado para modal */
.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: #007acc;
  border-radius: 8px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: #005fa3;
}

/* Responsividade menor que 480px */
@media (max-width: 480px) {
  .blog-container {
    padding: 20px 12px;
  }

  .article-title {
    font-size: 1.2rem;
  }

  .article-summary {
    font-size: 0.85rem;
  }

  .read-more-button {
    padding: 8px 20px;
    font-size: 0.9rem;
  }

  .modal-content {
    padding: 28px 24px;
  }

  .modal-title {
    font-size: 1.5rem;
  }
}
</style>

<!-- Lucide icons -->
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/lucide@latest/dist/css/lucide.css" />
